import { Component } from "react";
import { Switch, Route, Redirect } from 'react-router-dom';

import PlanList from "../component/features/plans/PlanList";
import { PlanAddEdit } from "../component/features/plans/PlanAddEdit";
import CurrentPlan from "../component/features/plans/CurrentPlan";
import PlanAssign from "../component/features/plans/PlanAssign";

export class PlanRouter extends Component {
    
    render() {
        return (
            <Switch>
                <Route exact path={"/plans"} component={PlanList} />
                <Route exact path={"/plans/add"} component={PlanAddEdit} />
                <Route exact path={"/plans/edit/:id"} component={PlanAddEdit} />
                <Route exact path={"/plans/current"} component={CurrentPlan} />
                <Route exact path={"/plans/assign"} component={PlanAssign} />
                <Redirect to="/not-found" />
            </Switch>
        )
    }
};